import { BasicSelect } from '@agro-club/frontend-shared'
import { TargetSkuTypes } from 'modules/domain/target2sku/common/types'
import { endpoints } from 'modules/endpoints'
import React, { useMemo } from 'react'
import { EntitySelect, EntitySelectProps } from 'views/components/EntitySelect/EntitySelect'
import { createGetList } from './common'

export type TargetSkuGrower = {
  id: string
  title: string
}

type TargetSkuGrowerFilter = {
  manufacturer_id?: string
  territory_id?: string
  title?: string
}

type TargetSkuGrowerSelectProps = EntitySelectProps<TargetSkuGrower> & {
  valueLabel?: string
  manufacturerId?: string
  territoryId?: string
  scope?: TargetSkuTypes.PedigreedGrower | 'default'
}

const getListForm = createGetList<TargetSkuGrower, TargetSkuGrowerFilter>(endpoints.target2sku('pedigreed-growers'))

const getListPedigreedGrowerFilter = createGetList<TargetSkuGrower, TargetSkuGrowerFilter>(
  endpoints.target2sku('pedigreed-grower/growers'),
)

const scopeManagerMap = {
  default: getListForm,
  [TargetSkuTypes.PedigreedGrower]: getListPedigreedGrowerFilter,
}

const getLabel = (item: TargetSkuGrower) => item.title

const getValue = (item: TargetSkuGrower) => item.id

export const TargetSkuGrowerSelect: React.VFC<TargetSkuGrowerSelectProps> = ({
  isDisabled,
  valueLabel,
  onChange,
  manufacturerId,
  territoryId,
  scope = 'default',
  ...props
}) => {
  const filter = useMemo(
    () => ({ manufacturer_id: manufacturerId, territory_id: territoryId }),
    [manufacturerId, territoryId],
  )
  const fakeValue = useMemo(() => (valueLabel ? { title: valueLabel, id: 'fake' } : undefined), [valueLabel])

  const testId = 'target-grower-select'

  return isDisabled ? (
    <BasicSelect
      isDisabled
      getOptionLabel={getLabel}
      getOptionValue={getValue}
      {...props}
      value={fakeValue}
      data-test-id={testId}
    />
  ) : (
    <EntitySelect
      filter={filter}
      getEntityList={scopeManagerMap[scope]}
      getOptionLabel={getLabel}
      getOptionValue={getValue}
      onChange={onChange}
      searchParamKey="title"
      data-test-id={testId}
      {...props}
    />
  )
}
